import React from 'react';
import './AddPropertyPage.scss';
import { useNavigate } from 'react-router-dom';
import PropertiesBatchImport from '@/components/dashboard/AddProperty/PropertiesBatchImport';
import AddPropertyForm from '@/components/dashboard/AddProperty/AddPropertyForm';
import UIPageTitle from '@/components/shared/UIPageTitle';
import UIButton from '@/components/shared/UIButton';
import { useCollapsibleSections } from '@/hooks/useCollapsibleSections';

const baseClass = 'AddPropertyPage';

const AddPropertyPage = () => {
  const navigate = useNavigate();
  const { getSectionState, toggleSection } = useCollapsibleSections(
    'add-property-page',
    {
      batchImport: true,
      addProperty: false,
    },
  );

  const renderHeaderActions = () => (
    <div className={`${baseClass}__header-actions`}>
      <UIButton
        variant="primary"
        outline
        size="medium"
        onClick={() => navigate('/properties')}
      >
        Back
      </UIButton>
    </div>
  );

  return (
    <div className={baseClass}>
      <UIPageTitle
        title="Property: New Property"
        action={renderHeaderActions()}
        showDivider={true}
        className={`${baseClass}__header`}
      />

      <AddPropertyForm
        collapsed={getSectionState('addProperty')}
        onToggleCollapse={() => toggleSection('addProperty')}
        className="mb-24"
      />

      <PropertiesBatchImport
        collapsed={getSectionState('batchImport')}
        onToggleCollapse={() => toggleSection('batchImport')}
      />
    </div>
  );
};

export default AddPropertyPage;
